import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

interface ApiResponse {
  success: true;
  isUnlinked: boolean;
}

const useUnlinkedStatus = () => {
  const { userId, orgId } = useAuth();
  return useQuery({
    queryKey: [Query.AppKeys['unlinked-status'], { userId }],
    enabled: !!userId && !orgId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    queryFn: async () => {
      const response = await axios.get<ApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/user/unlinked-status`,
      );
      return response.data;
    },
  });
};

export { useUnlinkedStatus };
